/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination} from "swiper";

const swiper = new Swiper(".serviceswiper", {
	modules: [Navigation, Pagination],
	grabCursor: true,
	pagination: {
		el: '.swiper-pagination',
	},	
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	slidesPerView: 1,
	spaceBetween: 40,
	breakpoints: {
	  768: {
		slidesPerView: 2,
		spaceBetween: 40,
	  },
	  1200: {
		slidesPerView: 3,
		spaceBetween: 40,
	  },
	  1400: {
		slidesPerView: 4,
		spaceBetween: 40,
	  },
	},
});

		









